import { useEffect, useState } from 'react';
import { Button } from '@/components/ui';

interface CompleteScreenProps {
  title?: string;
  message?: string;
  returnUrl?: string;
  autoRedirect?: boolean;
  redirectDelay?: number; // in seconds
}

export function CompleteScreen({
  title = 'Thank you!',
  message = 'Your response has been recorded successfully.',
  returnUrl,
  autoRedirect = true,
  redirectDelay = 3,
}: CompleteScreenProps) {
  const [countdown, setCountdown] = useState(redirectDelay);

  useEffect(() => {
    if (!returnUrl || !autoRedirect) return;

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location.href = returnUrl;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [returnUrl, autoRedirect]);

  const handleContinue = () => {
    if (returnUrl) {
      window.location.href = returnUrl;
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md text-center">
        {/* Success icon */}
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
          <svg
            className="h-8 w-8 text-green-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>

        <h1 className="mb-2 text-2xl font-semibold text-gray-900">{title}</h1>
        <p className="mb-6 text-gray-600">{message}</p>

        {returnUrl && (
          <>
            {autoRedirect && countdown > 0 ? (
              <p className="text-sm text-gray-500">
                Redirecting in {countdown} seconds...
              </p>
            ) : (
              <Button onClick={handleContinue} variant="primary">
                Continue
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
